/**
 * Carbon date field: a TextInput over the native type="date" control, so the
 * browser's own picker and keyboard entry apply and the value stays an ISO
 * `yyyy-mm-dd` string. `min`, `max` and `step` pass through. The picker
 * follows the in-app theme through `color-scheme` on <html>.
 */
import { forwardRef } from 'react'
import { TextInput, type TextInputProps } from './TextInput'

export type DateInputProps = Omit<TextInputProps, 'type'>

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(function DateInput(props, ref) {
  return <TextInput ref={ref} type="date" {...props} />
})

export default DateInput
